export default __webpack_public_path__ + "static/media/digifinex.ee0fe2d3.svg";